export const getI18nKey = (prefix, event) => {
  const eventName = event.toUpperCase().replaceAll('.', '_');
  return `${prefix}.${eventName}`;
};
